import { ReactElement } from 'react';

import {
   ConfidentialResourceAccessRequestQuery,
   ConfidentialResourceAccessRequestRevokeCommand,
   Practitioner,
} from '@dreryk/egabinet-medical-data-confidentiality-frontend-api';

import { refetchCqrsQuery, useCqrsCommand } from '@dreryk/command-query-react-common';
import { dispatchSnackbarPositiveEvent, ModalConfirmButton } from '@dreryk/react-components';
import { createInterpolatedTranslationKey, practitionerNameFormatter } from '@dreryk/react-common';

import { systemActivityTranslationKeys } from '../../../../translations';

type RevokeAccessConfirmButtonProps = {
   requestId: number;
   grantee: Practitioner;
   onSuccess: VoidFunction;
};

export const RevokeAccessConfirmButton = (props: RevokeAccessConfirmButtonProps): ReactElement => {
   const { executeAsync: revokeAccess } = useCqrsCommand<void, void>(
      () => {
         const command = new ConfidentialResourceAccessRequestRevokeCommand();
         command.requestId = props.requestId;
         return command;
      },
      {
         onSuccess: () => {
            dispatchSnackbarPositiveEvent(
               createInterpolatedTranslationKey(systemActivityTranslationKeys.revokeSuccess, {
                  practitionerName: practitionerNameFormatter(props.grantee),
               })
            );
            refetchCqrsQuery(ConfidentialResourceAccessRequestQuery);
            props.onSuccess();
         },
      }
   );

   return (
      <ModalConfirmButton label={systemActivityTranslationKeys.revokeAccess} onClick={async () => revokeAccess()} />
   );
};
